const ticketMenu: any = {
  id: "ticket",
  title: "Supporto",
  translate: "TITLES.SUPPORT",
  type: "collapsible",
  icon: "life-buoy",
  capability: "",
  children: [
    {
      id: "open-ticket",
      title: "Apri richiesta di supporto",
      translate: "MENU.OPEN_SUPPORT_REQUEST",
      type: "item",
      url: "#toggleOpenTicket",
    },
    {
      id: "my-tickets",
      title: "Le mie richieste di supporto",
      translate: "MENU.MY_SUPPORT_REQUEST",
      type: "item",
      url: "dashboard/ticket/my-list",
    },
    {
      id: "manage-ticket",
      title: "Gestione richieste di supporto",
      translate: "MENU.MANAGE_SUPPORT_REQUEST",
      capability: "view_ticket_list",
      type: "item",
      url: "dashboard/ticket/all-ticket-list",
    },
  ],
  order: 8,
};

export default ticketMenu;
